/* eslint import/prefer-default-export: "off" */

/**
 * Resizes a Shopify image on the frontend.
 * Expects `size` to be formatted like the Liquid filter, e.g. '450x' or 300x200'.
 * @param {*} image
 * @param {*} size
 * @param  scale
 */
export const getSizedImageUrl = (image, size, scale = false) => {
  if (!image) return '';
  const src = image.src ? image.src : image;
  const currentSizeRegEx = /_(pico|icon|thumb|small|compact|medium|large|grande|original|\d{1,4}x(\d{1,4})?|master)+\./g;
  const extensionRegEx = /\.jpg|\.png|\.gif|\.jpeg/g;
  const deviceScale = scale ? `@${scale}x` : '';

  // remove any current image size then add the new image size
  return src.replace(currentSizeRegEx, '.').replace(extensionRegEx, (match) => `_${size}${deviceScale}${match}`);
};

/**
 * Creates a simple srcset value with 1x & 2x srcs included
 * @param {*} image
 * @param {*} size
 */
export const srcset = (image, size) => {
  if (!image) return '';
  const src = image.src ? image.src : image;
  return `${getSizedImageUrl(src, size)}, ${getSizedImageUrl(src, size, 2)} 2x`;
};
